"use client";

import { useIntl } from "react-intl";
import CardSlider from "../Components/CardSlider/CardSlider";
import Download from "../Components/Download/Download";
import EnhanceYourTrip from "../Components/EnhanceYourTrip/EnhanceYourTrip";
import HelpInfo from "../Components/HelpInfo/HelpInfo";
import ImageSlider from "../Components/LandingPage/ImageSlider/ImageSlider";
import SearchComponent from "../Components/LandingPage/SearchComponent/SearchComponent";
import Section from "../Components/Section/Section";
import TrustBuilderWidget from "../Components/TrustBuilderWidget/TrustBuilderWidget";
import PopularDestinationWidget from "../Components/LandingPage/PopularDestinationWidget/PopularDestinationWidget";
import RoutesWidget from "../Components/LandingPage/RoutesWidget/RoutesWidget";
import NewsWidget from "../Components/LandingPage/NewsWidget/NewsWidget";
import "./style.css";
import DepartureFromSlider from "../Components/CardSlider/DepartureFromSlider";
import PopularTripsHomepage from "../Components/EnhanceYourTrip/PopularTripsHomepage";
import TodaysTrainFromSlider from "../Components/CardSlider/TodaysTrainFromSlider";

export default function Home() {
  const intl = useIntl();
  return (
    <div className="home_page">
      <div className="banner_bg">
        <div className="container">
          <SearchComponent className={"sticky_search_page"} />
          <div className="main-slider">
            <div className="">
              <ImageSlider />
            </div>
          </div>
        </div>
      </div>

      <Section type="popular_trip">
        <div className="container">
          <PopularTripsHomepage />
        </div>
      </Section>


      <Section type="popular_destinations">
        <div className="container">
          <PopularDestinationWidget
            title={intl.formatMessage({ id: "popularDestinationsTitle" })}
            subtitle={intl.formatMessage({ id: "popularDestinationsSubtitle" })}
          />
        </div>
      </Section>

      {/* Departures-from ("Departures from <station> / Your departures") section
          hidden per request (branch: departures_hide). Restore by uncommenting. */}
      {/* <Section type="departures_from">
        <div className="container">
          <DepartureFromSlider />
        </div>
      </Section> */}

      {/* <Section type="today_trains_leaving_from">
        <div className="container">
          <TodaysTrainFromSlider />
        </div>
      </Section> */}

      <Section type="trust_builder">
        <div className="container">
          <EnhanceYourTrip />
        </div>
      </Section>

      <Section type="help_usefull">
        <div className="container">
          <HelpInfo />
        </div>
      </Section>

      <Section type="trust_builder">
        <div className="container">
          <Download />
        </div>
      </Section>


      {/* <Section type="popular_destinations" >
        <div className="container">
          <RoutesWidget />
        </div>
      </Section> */}

      {/* This is not part of simplified home page */}
      {/* <Section type="popular_trip">
        <div className="container">
          <CardSlider
            sliderName="popularTip"
            sliderType="popular"
            title={intl.formatMessage({ id: "popularTripText" })}
            subTitle={intl.formatMessage({ id: "yourPopularTripsText" })}
          />
        </div>
      </Section> */}

      {/* This is not part of simplified home page */}
      {/* <Section type="departures_from">
        <div className="container">
          <CardSlider
            sliderName="departureFrom"
            title="Departures from"
            sliderType="departure"
            subTitle="Your departures"
          />
        </div>
      </Section> */}

      {/* <Section type="newsletter">
        <div className="container">
          <NewsWidget />
        </div>
      </Section> */}

      {/* <Section type="download_app">
        <div className="container">
          <Download />
        </div>
      </Section> */}

      {/* <Section type="help_usefull">
         <div className="container">
          <HelpInfo />
        </div>
      </Section> */}

      {/* This is not part of simplified home page */}
      {/* <Section type="today_trains_leaving_from">
        <div className="container">
          <CardSlider
            sliderName="trainFrom"
            title="Today Trains from"
            sliderType="departure"
            subTitle="Your next trains"
          />
        </div>
      </Section> */}

      {/* This is not part of simplified home page */}
      {/* <div className="container">
        <EnhanceYourTrip />
      </div> */}
    </div>
  );
}
